import * as React from 'react';
import { connect } from 'react-redux';

import { ICoverImage, IDocument } from '../../infrastructure/interfaces';
import CoverImageEditorForm from '../DocumentEditor/CoverImageEditorForm';
import {coverImagesForDocument} from '../../infrastructure/CoverImageTypes';
import {
  changeCoverImage,
} from '../../actions/actions';

export interface ICoverImagesChoosingProps {
  document: IDocument;
  coverImages: ICoverImage[];
  changeCoverImage(brand: ICoverImage): void;
}

export interface ICoverImagesChoosingState { }

const mapDispatchToProps = (dispatch: any): any => {
  return {
    changeCoverImage: (brand: ICoverImage): void => {
      dispatch(changeCoverImage(brand));
    },
  };
};

const mapStateToProps = (state: any): any => {
  return {
    document: state.document,
    coverImages: state.wizard.coverImages,
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class CoverImagesChoosing extends React.Component<any, any> {
  render() {
    return (
      <div>
        <div className="stepHeader">
          <div className="stepMessage">
            Choose cover background image:
          </div>
          <div className="stepMessage2">
            You can change this selection later
        </div>
        </div>
        <CoverImageEditorForm
          className="stepContent settingsCropsListContainer settingsCropsListContainer--crops"
          document={this.props.document}
          coverImages={coverImagesForDocument(this.props.coverImages, this.props.document)}
          onCoverImageChange={this.props.changeCoverImage}
        />
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/Steps/CoverImagesChoosing.tsx